import { FETCH_NEXT_STEP_CARD_REQUEST, FETCH_NEXT_STEP_CARD_SUCCESS, FETCH_NEXT_STEP_CARD_FAILURE } from "../../actions/opportunities/nextStepCardActions";


  const initialState = {
    nextStepCardLoading: false,
    nextStepCardData: [],
    nextStepCardError: null,
  };
  
  const nextStepCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NEXT_STEP_CARD_REQUEST:
        return { ...state, nextStepCardLoading: true , payload: action.payload};
      case FETCH_NEXT_STEP_CARD_SUCCESS:
        return { ...state, nextStepCardLoading: false, nextStepCardData: action.payload };
      case FETCH_NEXT_STEP_CARD_FAILURE:
        return { ...state, nextStepCardLoading: false, nextStepCardError: action.payload };       
      default:
        return state;
    }
  };
  
  export default nextStepCardReducer;
  